import React from 'react'
import { CCard, CCardBody, CBadge, CRow, CCol } from '@coreui/react-pro'

const CommunityPlayerOfRoundModal = ({ item }) => {
  const { payload } = item

  if (!payload) return <p>No player data available</p>

  return (
    <div>
      <div style={{ textAlign: 'center', marginBottom: '20px' }}>
        <h1 style={{ fontSize: '48px', marginBottom: '10px' }}>⭐</h1>
        <h5>Player of the Round</h5>
        <CBadge color="success">PLAYER OF THE ROUND</CBadge>
      </div>

      <CCard style={{ marginBottom: '15px' }}>
        <CCardBody>
          <div style={{ marginBottom: '15px' }}>
            <h6>{payload.full_name || 'N/A'}</h6>
            <small style={{ color: '#666' }}>Team: {payload.team_name || 'N/A'}</small>
          </div>

          <CRow>
            <CCol md="6">
              <div
                style={{
                  marginBottom: '12px',
                  padding: '10px',
                  backgroundColor: '#f5f5f5',
                  borderRadius: '4px',
                }}
              >
                <strong>Runs:</strong> <CBadge color="info">{payload.round_runs || 0}</CBadge>
              </div>
              <div style={{ padding: '10px', backgroundColor: '#f5f5f5', borderRadius: '4px' }}>
                <strong>Wickets:</strong>{' '}
                <CBadge color="danger">{payload.round_wickets || 0}</CBadge>
              </div>
            </CCol>
            <CCol md="6">
              <div
                style={{
                  padding: '10px',
                  backgroundColor: '#f5f5f5',
                  borderRadius: '4px',
                  textAlign: 'center',
                }}
              >
                <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#0c63e4' }}>
                  {payload.round_points || 0}
                </div>
                <small>Total Points</small>
              </div>
            </CCol>
          </CRow>

          {payload.description && (
            <div style={{ marginTop: '15px', paddingTop: '15px', borderTop: '1px solid #ddd' }}>
              <strong>Details:</strong>
              <p style={{ marginTop: '8px', marginBottom: 0 }}>{payload.description}</p>
            </div>
          )}
        </CCardBody>
      </CCard>
    </div>
  )
}

export default CommunityPlayerOfRoundModal
